module.exports = __webpack_public_path__ + "img/UTCAMP-5.6e428d0a.jpg";